import React from 'react'

function Icon(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" fill="none" viewBox="0 0 15 18" {...props}>
            <path
                fill="#1A1A1A"
                d="M2.5 17.615c-.46 0-.844-.154-1.153-.462A1.565 1.565 0 01.885 16V5.115c0-.142.048-.261.143-.356a.484.484 0 01.357-.144c.142 0 .261.048.357.144a.484.484 0 01.143.356V16c0 .154.064.295.192.423s.27.192.423.192h7.885c.142 0 .261.048.357.144a.484.484 0 01.143.356.484.484 0 01-.143.357.484.484 0 01-.357.143H2.5zm3-3c-.46 0-.844-.154-1.153-.462A1.564 1.564 0 013.885 13V2.23c0-.46.154-.844.462-1.152A1.565 1.565 0 015.5.615h7.77c.46 0 .844.154 1.152.463.309.308.463.692.463 1.153V13c0 .46-.154.844-.463 1.153a1.564 1.564 0 01-1.153.462H5.5zm0-1h7.77a.588.588 0 00.423-.192.588.588 0 00.192-.423V2.23a.588.588 0 00-.192-.422.588.588 0 00-.424-.193H5.5a.588.588 0 00-.423.193.588.588 0 00-.192.423V13c0 .154.064.295.192.423s.27.192.423.192z"
            ></path>
        </svg>
    )
}

export default Icon
